import { useFormikContext } from 'formik';
import { get } from 'lodash';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { Col } from 'hb-react/shared/components/DesignSystem/Grid';
import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

import { type FormValues } from '../types';

export const Status = () => {
  const { values } = useFormikContext<FormValues>();

  const isExpired = dayjs(values.expires_at).isBefore(dayjs());

  return values.draft ? null : (
    <Col>
      <Box alignItems="center" justifyContent="flex-end">
        {s__('JobForm|Status:')}
        <Pill
          $isExpired={!values.draft && isExpired}
          $status={values.draft ? 'draft' : values.status}
        />
      </Box>
    </Col>
  );
};

const Pill = styled(Box).attrs<{
  $isExpired: boolean;
  $status: 'approved' | 'draft' | 'pending' | 'rejected';
}>(({ $isExpired, $status, theme }) => {
  const details = get(
    {
      approved: { bg: theme.colors.grass, children: s__('JobForm|Open') },
      draft: { bg: theme.colors.dustyGray, children: s__('JobForm|Draft') },
      expired: {
        bg: theme.colors.mandarine,
        children: s__('JobForm|Expired'),
      },
      pending: { bg: theme.colors.primary, children: s__('JobForm|Pending') },
      rejected: { bg: theme.colors.fire, children: s__('JobForm|Rejected') },
    },
    $isExpired && !['pending', 'rejected'].includes($status)
      ? 'expired'
      : $status,
  );

  return {
    as: 'span',
    ...details,
    color: theme.colors.white,
    display: 'inline-block',
    ml: 1,
    px: 2,
    py: '1px',
  };
})`
  border-radius: 2px;
`;
